//provides sibling communication between components
import Vue from 'vue'
export const EventBus = new Vue();

export const OnUniversalDonorSelection = 'OnUniversalDonorSelection';
